export default {
	name: "UserStatistics",
	methods: {
      /* ---------- Alerts and errors ---------- */
      handleAlert(daOrigin, daMessage, daClass, daPageOrModal) {
         // The API sends some messages as an array
         const message = Array.isArray(daMessage) ? daMessage[0] : daMessage;
         this.$displayAlert(daOrigin, message, daClass, daPageOrModal);
      },
      handleError(daOrigin, error, daClass, daPageOrModal) {
         this.defaultAlert.alertMessage = error && error.data && error.data.message ? error.data.message : error;
         this.handleAlert(daOrigin, this.defaultAlert.alertMessage, daClass, daPageOrModal);
         console.error("Error:", this.defaultAlert.alertMessage);
      },
      // true = the session ended and the user was logged out
      handleAuthError(response) {
         const code = response.data?.code;
         if (code === "JWT_EXPIRED" || code === "CSRF_INVALID" || code === "AUTH_REQUIRED") {
            this.$forceLogOut("danger", response.data.message);
            return true;
         }
         return false;
      },
      handleNetworkError(error) {
         if (error.message === "Network Error") {
            this.handleAlert("ending", "No internet connection. Please check your network.", "danger", "page");
         } else {
            this.handleAlert("ending", "Something went wrong. Please try again later.", "danger", "page");
         }
      },

      /* ---------- Responses ---------- */
      handleFetchSuccess(response) {
         const r = response.data.results || {};
         this.stats = {
            totals: r.totals || this.getDefaultStats().totals,
            by_country: r.by_country || [],
            by_company: r.by_company || [],
         };
         if (r.token) localStorage.setItem("jwt", r.token);
      },

      /* ---------- Small helpers ---------- */
      formatNumber(value) {
         return Number(value || 0).toLocaleString();
      },
      // Whole-number percentage, 0 when there is nothing to divide by
      percent(part, total) {
         return total ? Math.round((Number(part) / Number(total)) * 100) : 0;
      },
	},
};